import { ItemHolder, StyledItem } from 'components/CompleteFooter/CompleteFooter.styles';
import { Item } from 'components/CompleteFooter/CompleteFooter.type';
import React from 'react';

const RenderItem = ({ item }: { item: Item }): React.ReactElement<any> => (
  <ItemHolder>
    <StyledItem
      to={{
        pathname: item.LINK,
      }}
      target='_blank'
    >
      {item.TEXT}
    </StyledItem>
  </ItemHolder>
);

export default RenderItem;
